import styles from "./SettingsTabSection.module.scss";

interface ISettingsTabSectionProps {
    labelKey: string;
    dataCy: string;
    children: React.ReactNode;
}

export function SettingsTabSection(props: ISettingsTabSectionProps): JSX.Element {
    return (
        <section>
            <header className={styles.headerSection}>
                <h3
                    className="thin-font"
                    data-cy={props.dataCy}
                >
                    {cacheStore.GetString(props.labelKey)}
                </h3>
            </header>
            {props.children}
        </section>
    );
}
